const delayedModalClose = (cancel, resetSavedProperty, time = 1000) =>
  void setTimeout(() => {
    cancel();
    resetSavedProperty();
  }, time);

export default delayedModalClose;
